<template>
  <div>
    <div v-if="files && files.length" v-loading="uploading">
      <div class="c-g9 m-b-5">将要上传的文件:</div>
      <div v-for="(i, index) in files" :key="index">
        <span>{{ i.name }}</span>
        <el-button type="text" @click="deleteOne(index)"
          ><i class="iconfont icon-close text-danger"></i
        ></el-button>
      </div>
      <div class="btnDiv">
        <el-button @click="deleteAll" size="mini">清空</el-button>
        <el-button type="primary" @click="uploadConfirm" size="mini">确认上传</el-button>
      </div>
    </div>
    <div class="tc" v-else>
      <el-upload
        drag
        action="https://xx.yy.zz"
        :auto-upload="false"
        :show-file-list="false"
        :on-change="fileChanged"
        :accept="`${accept || ''}`"
        :multiple="multiple"
      >
        <i class="el-icon-upload" style="font-size:67px"></i>
        <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
      </el-upload>
    </div>
  </div>
</template>
<script type="text/babel">
import ApiMixinFiles from '@/assets/js/api/files'
import ApiMixin from '@/assets/js/api/index'
import ApiMixinSystem from '@/assets/js/api/systemParams'

export default {
  mixins: [ApiMixinFiles, ApiMixin, ApiMixinSystem],
  props: [
    'multiple',
    'accept',
    'hdd',
    'pureFile',
    'chunk',
    'needFormData',
    'flowStepId',
    'ownerId',
    'isClashReport',
  ],
  data() {
    return {
      files: [],
      uploading: false,
      acceptList: '',
      perChunkSize: 2 * 1024 * 1024,
    }
  },
  computed: {
    currentProject() {
      return this.$store.getters.currentProject || {}
    },
  },
  methods: {
    deleteOne(index) {
      this.files.splice(index, 1)
    },
    deleteAll() {
      this.files = []
    },
    // 获取文件类型白名单
    async getFileType() {
      const params = {
        where: {
          keyWord: 'uploadExtensionWhitelist',
        },
      }
      const res = await this.apiSystemParams({
        method: 'getSystem',
        params,
      })
      if (res.success && res.dataList && res.dataList.length > 0) {
        return res.dataList[0].parameterValue
      }
      return []
    },
    async fileChanged(file) {
      console.log('file', file)
      const fileType = await this.getFileType()
      let arr = _.compact(_.split(fileType, ';'))
      arr = _.map(arr, (item) => {
        if (item.indexOf('*') !== -1) {
          item = _.replace(item, '*', '.?')
        }
        return item
      })
      const strReg = new RegExp(`(${arr.join('|')})$`)
      if (strReg.test(file.name)) {
        this.files.push(file)
        if (!this.multiple) {
          this.uploadConfirm()
        }
      } else {
        this.$message.error('文件格式有误!')
      }
    },
    // async uploadConfirm() {
    //   const currentFile = this.files[0]
    //   const totalChunk = Math.ceil(currentFile.size / this.perChunkSize)
    //   console.log('当前file数据', currentFile)
    //   const res = await this.apiFileUpload({
    //     method: 'getmaxchunk',
    //     params: {
    //       siteId: this.currentProject.id,
    //       documentId: '',
    //       fileName: encodeUrl(currentFile.name),
    //       md5: md5(currentFile),
    //       totalChunk,
    //       origin: 1,
    //       size: currentFile.size,
    //     },
    //   })
    //   this.uploading = false
    //   console.log(res)
    //   if (res && res.success) {
    //     this.files = []
    //     this.$emit('uploadFinish', res.data)
    //   }
    // },
    async uploadConfirm() {
      const files = _.map(this.files, (i) => {
        return i.raw
      })
      if (this.pureFile) {
        this.files = []
        this.$emit('uploadFinish', files)
      } else if (this.chunk) {
        // 分片上传
        _.forEach(this.files, (file) => {
          // {fileName:'',chunk: {}}
          let start = 0
          let end
          let chunk
          let index = 0
          const chunks = []
          const totalChunk = Math.ceil(file.raw.size / this.perChunkSize)
          for (let i = 0; i < totalChunk; i += 1) {
            end = start + this.perChunkSize
            if (end > file.raw.size) {
              end = file.raw.size
            }
            chunk = file.raw.slice(start, end)
            chunks.push({
              fileName: `${file.raw.name}_${index}`,
              chunk,
            })
            start = end
            index += 1
          }
          console.log(chunks)
          this.$emit('uploadFinish', chunks)
        })
      } else {
        this.uploading = true
        const formData = new FormData()
        _.forEach(files, (i) => {
          formData.append('file', i)
        })
        if (this.hdd) {
          // 工作流步骤id绑定
          if (this.ownerId && (this.flowStepId === '' || this.flowStepId)) {
            formData.append('flowStepId', this.flowStepId)
            formData.append('ownerId', this.ownerId)
          }
          formData.append('siteId', this.currentProject.id)
          const res = await this.apiFileHHD({
            method: 'upload',
            formData,
          })
          this.uploading = false
          console.log('hdd res', res)
          if (res && res.success) {
            this.files = []
            this.$emit('uploadFinish', res.dataList)
          }
        } else {
          let res
          if (this.isClashReport) {
            res = await this.apiUploadFilesWithSiteId({
              params: {
                siteId: this.currentProject.id,
              },
              formData,
            })
          } else {
            res = await this.apiUploadFiles({
              formData,
            })
          }
          this.uploading = false
          if (res && res.success) {
            console.log('上传文件服务', this.needFormData)
            console.log('文件formData', formData)
            if (this.needFormData) {
              this.$emit('getFormData', formData)
            }
            this.files = []
            this.$emit('uploadFinish', res.data)
          }
        }
      }
    },
  },
}
</script>
<style lang="scss" scoped>

.btnDiv {
  /deep/ .el-button--mini {
    padding: 7px 10px !important;
    margin-left: 2px !important;
  }
}

</style>
